/* Rudie cart: "You may also like" (multi, auto, excludes cart items) + one-click upsell toggle. */
(function () {
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function money(c) { var v = c / 100; return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2)); }

  function refreshDrawer(res) {
    if (!res || !res.sections) return;
    var cd = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
    var cur = document.querySelector('#CartDrawer');
    if (cd && cur) cur.innerHTML = cd.innerHTML;
    if (res.sections['cart-icon-bubble']) {
      var doc = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
      var nb = doc.querySelector('.shopify-section') || doc.body.firstElementChild;
      var cb = document.getElementById('cart-icon-bubble');
      if (cb && nb) cb.innerHTML = nb.innerHTML;
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer) { drawer.classList.remove('is-empty'); if (drawer.open) drawer.open(); }
  }
  function cartAdd(variantId, after) {
    fetch(ROOT + 'cart/add', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (res) { refreshDrawer(res); if (after) after(true); }).catch(function () { if (after) after(false); });
  }

  if (!customElements.get('cart-upsell')) {
    customElements.define('cart-upsell', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const track = this.querySelector('.rudie-addons__track');
        const previous = this.querySelector('[data-addon-prev]');
        const next = this.querySelector('[data-addon-next]');
        if (!track) return;
        const updateArrows = () => {
          previous.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 3;
        };
        const move = direction => track.scrollBy({left: direction * (track.firstElementChild.getBoundingClientRect().width + 10), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        previous.addEventListener('click', () => move(-1), options);
        next.addEventListener('click', () => move(1), options);
        track.addEventListener('scroll', updateArrows, options);
        track.addEventListener('keydown', event => {
          if (event.target !== track) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, options);
        this.resize = new ResizeObserver(updateArrows);
        this.resize.observe(track);
        this.querySelectorAll('.rudie-addon').forEach(card => {
          const select = card.querySelector('[data-addon-variant]');
          const button = card.querySelector('[data-addon-add]');
          select.addEventListener('change', event => {
            event.stopPropagation();
            const selected = select.selectedOptions[0];
            card.querySelector('[data-size-label]').textContent = selected.textContent;
            card.querySelector('[data-size-toggle]').classList.add('is-selected');
            card.querySelector('[data-addon-price]').textContent = selected.dataset.price;
            const was = card.querySelector('[data-addon-was]');
            if (was) was.textContent = selected.dataset.was;
            button.disabled = !select.value || button.dataset.pending === 'true';
          }, options);
          card.querySelector('[data-size-toggle]').addEventListener('click', event => { event.preventDefault(); event.stopPropagation(); this.openPicker(card, event.currentTarget); }, options);
          button.addEventListener('click', () => this.add(card), options);
        });
        updateArrows();
      }
      disconnectedCallback() {
        this.guide?.close();
        this.guide?.remove();
        this.picker?.close();
        this.picker?.remove();
        this.controller?.abort();
        this.resize?.disconnect();
      }
      openPicker(card, trigger) {
        if (this.picker?.open) return;
        const select = card.querySelector('[data-addon-variant]');
        const dialog = document.createElement('dialog');
        dialog.className = 'rudie-size-picker';
        dialog.setAttribute('aria-labelledby', 'RudieSizePickerTitle');
        const header = document.createElement('div');
        header.className = 'rudie-size-picker__heading';
        const title = document.createElement('h2');
        title.id = 'RudieSizePickerTitle';
        title.textContent = this.dataset.chooseSize;
        header.appendChild(title);
        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'rudie-size-picker__close';
        close.setAttribute('aria-label', this.dataset.closeSize);
        close.textContent = '×';
        close.addEventListener('click', () => dialog.close());
        header.appendChild(close);
        const product = document.createElement('p');
        product.className = 'rudie-size-picker__product';
        product.textContent = card.querySelector('.rudie-addon__title').textContent;
        dialog.append(header, product);
        if (card.dataset.hasGuide === 'true') {
          const help = document.createElement('button');
          help.type = 'button';
          help.className = 'rudie-size-picker__help';
          help.setAttribute('aria-haspopup', 'dialog');
          help.textContent = 'ⓘ ' + this.dataset.sizeHelp;
          help.addEventListener('click', () => this.openGuide(help));
          dialog.appendChild(help);
        }
        const sizes = document.createElement('div');
        sizes.className = 'rudie-size-picker__sizes';
        for (const option of select.options) {
          if (!option.value) continue;
          const choice = document.createElement('button');
          choice.type = 'button';
          choice.textContent = option.textContent;
          choice.disabled = option.disabled;
          choice.setAttribute('aria-pressed', String(select.value === option.value));
          choice.addEventListener('click', () => {
            select.value = option.value;
            select.dispatchEvent(new Event('change', {bubbles: true}));
            dialog.close();
          });
          sizes.appendChild(choice);
        }
        dialog.appendChild(sizes);
        this.picker = dialog;
        document.body.appendChild(dialog);
        if (typeof removeTrapFocus === 'function') removeTrapFocus();
        dialog.addEventListener('cancel', event => {
          event.preventDefault();
          const stopEscape = e => {if (e.key !== 'Escape') return; e.stopImmediatePropagation(); document.removeEventListener('keyup', stopEscape, true);};
          document.addEventListener('keyup', stopEscape, true);
          setTimeout(() => document.removeEventListener('keyup', stopEscape, true), 1000);
          dialog.close();
        });
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        dialog.addEventListener('close', () => {
          dialog.remove();
          this.picker = null;
          const drawer = document.querySelector('cart-drawer.active #CartDrawer');
          if (drawer && typeof trapFocus === 'function') trapFocus(drawer, this.isConnected ? trigger : drawer.querySelector('.drawer__close'));
        }, {once: true});
        dialog.showModal();
        (sizes.querySelector('[aria-pressed="true"]') || sizes.querySelector('button:not(:disabled)') || close).focus();
      }
      openGuide(trigger) {
        if (this.guide?.open) return;
        const template = this.querySelector('[data-addon-guide-template]');
        if (!template) return;
        const dialog = template.content.firstElementChild.cloneNode(true);
        this.guide = dialog;
        document.body.appendChild(dialog);
        if (typeof removeTrapFocus === 'function') removeTrapFocus();
        dialog.querySelectorAll('[data-guide-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        dialog.addEventListener('cancel', event => {
          event.preventDefault();
          const stopEscape = keyEvent => {
            if (keyEvent.key !== 'Escape') return;
            keyEvent.stopImmediatePropagation();
            document.removeEventListener('keyup', stopEscape, true);
          };
          document.addEventListener('keyup', stopEscape, true);
          setTimeout(() => document.removeEventListener('keyup', stopEscape, true), 1000);
          dialog.close();
        });
        dialog.addEventListener('close', () => {
          dialog.remove();
          this.guide = null;
          if (this.picker?.open) { trigger.focus(); return; }
          const drawer = document.querySelector('cart-drawer.active #CartDrawer');
          if (drawer && typeof trapFocus === 'function') trapFocus(drawer, this.isConnected ? trigger : drawer.querySelector('.drawer__close'));
        }, {once: true});
        dialog.showModal();
        dialog.querySelector('[data-guide-close]').focus();
      }
      async add(card) {
        if (this.busy) return;
        const select = card.querySelector('[data-addon-variant]');
        const button = card.querySelector('[data-addon-add]');
        if (!select.value || button.dataset.pending === 'true') return;
        const status = this.querySelector('.rudie-addons__status');
        const label = button.textContent;
        this.busy = true;
        this.setAttribute('aria-busy', 'true');
        this.querySelectorAll('[data-addon-add]').forEach(b => { b.disabled = true; });
        button.textContent = this.dataset.adding;
        status.textContent = '';
        try {
          const item = { id: Number(select.value), quantity: 1 };
          if (card.dataset.offer === 'true') item.properties = { _rudie_offer: 'bralette-cart-10-v1' };
          const response = await fetch(ROOT + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({items: [item], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname + location.search})
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || this.dataset.error);
          const drawer = document.querySelector('cart-drawer');
          if (!data.sections?.['cart-drawer'] || !data.sections?.['cart-icon-bubble']) {
            location.assign(ROOT + 'cart'); return;
          }
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
          const region = drawer.querySelector('#CartDrawer-LiveRegionText');
          if (region) region.textContent = this.dataset.added;
          if (typeof trapFocus === 'function') trapFocus(drawer.querySelector('#CartDrawer'), drawer.querySelector('.drawer__close'));
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items', cartData: data});
        } catch (error) {
          status.textContent = error.message || this.dataset.error;
          button.textContent = label;
          this.querySelectorAll('.rudie-addon').forEach(c => {
            const b = c.querySelector('[data-addon-add]');
            b.disabled = !c.querySelector('select').value || b.dataset.pending === 'true';
          });
        } finally {
          this.busy = false;
          this.removeAttribute('aria-busy');
        }
      }
    });
  }
  /* ---------- One-click upsell (checkbox) ---------- */
  if (!customElements.get('cart-oneclick')) {
    customElements.define('cart-oneclick', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.done) return; this.dataset.done = '1';
        var self = this;
        var cb = this.querySelector('input[type="checkbox"]');
        var vid = this.dataset.vid;
        if (!cb || !vid) return;
        cb.addEventListener('change', function () {
          cb.disabled = true;
          if (cb.checked) {
            cartAdd(vid, function () { cb.disabled = false; });
          } else {
            // find line + set qty 0
            fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
              var line = 0; (c.items || []).forEach(function (it, i) { if (String(it.variant_id) === String(vid)) line = i + 1; });
              if (!line) { cb.disabled = false; return; }
              fetch(ROOT + 'cart/change', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: line, quantity: 0, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname }) })
                .then(function (r) { return r.json(); }).then(function (res) { refreshDrawer(res); }).catch(function () { cb.disabled = false; });
            });
          }
        });
      }
    });
  }
})();
